export const dict = {
  "ui.sessionReview.title": "Изменения сессии",
  "ui.sessionReview.title.git": "Изменения Git",
  "ui.sessionReview.title.branch": "Изменения ветки",
  "ui.sessionReview.title.lastTurn": "Последние изменения",
  "ui.sessionReview.diffStyle.unified": "Объединённый",
  "ui.sessionReview.diffStyle.split": "Разделённый",
  "ui.sessionReview.openFile": "Открыть файл",
  "ui.sessionReview.selection.line": "строка {{line}}",
  "ui.sessionReview.selection.lines": "строки {{start}}-{{end}}",
  "ui.sessionReview.expandAll": "Развернуть всё",
  "ui.sessionReview.collapseAll": "Свернуть всё",

  "ui.sessionReview.change.added": "Добавлено",
  "ui.sessionReview.change.removed": "Удалено",
  "ui.sessionReview.change.modified": "Изменено",
  "ui.sessionReview.image.loading": "Загрузка...",
  "ui.sessionReview.image.placeholder": "Изображение",
  "ui.sessionReview.largeDiff.title": "Diff слишком большой для отображения",
  "ui.sessionReview.largeDiff.meta": "Лимит: {{limit}} изменённых строк. Текущий: {{current}} изменённых строк.",
  "ui.sessionReview.largeDiff.renderAnyway": "Отобразить всё равно",
  "ui.fileMedia.kind.image": "изображение",
  "ui.fileMedia.kind.audio": "аудио",
  "ui.fileMedia.state.removed": "{{kind}} удалено",
  "ui.fileMedia.state.loading": "Загружается {{kind}}...",
  "ui.fileMedia.state.error": "Не удалось загрузить {{kind}}",
  "ui.fileMedia.state.unavailable": "{{kind}} недоступно",
  "ui.fileMedia.binary.title": "Бинарный файл",
  "ui.fileMedia.binary.description.path": "Невозможно отобразить {{path}}, так как это бинарный файл.",
  "ui.fileMedia.binary.description.default": "Невозможно отобразить этот файл, так как он бинарный.",
  "ui.lineComment.label.prefix": "Комментарий к ",
  "ui.lineComment.label.suffix": "",
  "ui.lineComment.editorLabel.prefix": "Комментирование: ",
  "ui.lineComment.editorLabel.suffix": "",
  "ui.lineComment.placeholder": "Добавить комментарий",
  "ui.lineComment.submit": "Комментировать",
  "ui.sessionTurn.steps.show": "Показать шаги",
  "ui.sessionTurn.steps.hide": "Скрыть шаги",
  "ui.sessionTurn.summary.response": "Ответ",
  "ui.sessionTurn.diff.showMore": "Показать ещё изменений ({{count}})",
  "ui.sessionTurn.diffs.changed": "Изменено",
  "ui.sessionTurn.diffs.showAll": "Показать все",
  "ui.sessionTurn.diffs.showLess": "Показать меньше",
  "ui.sessionTurn.diffs.more": "+{{count}} файлов",

  "ui.sessionTurn.retry.retrying": "повтор",
  "ui.sessionTurn.retry.inSeconds": "через {{seconds}}с",
  "ui.sessionTurn.retry.attempt": "попытка №{{attempt}}",
  "ui.sessionTurn.retry.attemptLine": "{{line}} - попытка №{{attempt}}",
  "ui.sessionTurn.retry.geminiHot": "gemini сейчас перегружен",
  "ui.sessionTurn.error.freeUsageExceeded": "Лимит бесплатного использования превышен",
  "ui.sessionTurn.error.addCredits": "Добавить кредиты",

  "ui.sessionTurn.status.delegating": "Делегирование работы",
  "ui.sessionTurn.status.planning": "Планирование следующих шагов",
  "ui.sessionTurn.status.gatheringContext": "Исследую",
  "ui.sessionTurn.status.gatheredContext": "Исследовано",
  "ui.sessionTurn.status.searchingCodebase": "Поиск в кодовой базе",
  "ui.sessionTurn.status.searchingWeb": "Поиск в интернете",
  "ui.sessionTurn.status.makingEdits": "Внесение изменений",
  "ui.sessionTurn.status.runningCommands": "Выполнение команд",
  "ui.sessionTurn.status.working": "Работаю",
  "ui.sessionTurn.status.completed": "Выполнено",
  "ui.sessionTurn.verification.passed": "Проверено",
  "ui.sessionTurn.verification.failed": "Проверка не пройдена",
  "ui.sessionTurn.verification.unverified": "Не проверено",
  "ui.sessionTurn.verification.not_required": "Проверка не требуется",
  "ui.sessionTurn.verification.checks.one": "{{count}} проверка",
  "ui.sessionTurn.verification.checks.other": "{{count}} проверок",
  "ui.sessionTurn.verification.details.show": "Показать подробности проверки",
  "ui.sessionTurn.verification.details.hide": "Скрыть подробности проверки",
  "ui.sessionTurn.verification.exitCode": "Код завершения: {{code}}",
  "ui.sessionTurn.verification.noChecks": "Файлы изменены, но проверочная команда не запускалась.",
  "ui.sessionTurn.verification.attempts.one": "{{count}} автоматическая попытка",
  "ui.sessionTurn.verification.attempts.other": "{{count}} автоматических попыток",
  "ui.sessionTurn.verification.requirement.missing": "Не выполнена обязательная проверка",
  "ui.sessionTurn.verification.requirement.optional": "Необязательная",
  "ui.sessionTurn.verification.review.passed": "Семантическое ревью пройдено",
  "ui.sessionTurn.verification.review.failed": "Семантическое ревью нашло проблемы",
  "ui.sessionTurn.verification.review.error": "Не удалось выполнить семантическое ревью",
  "ui.sessionTurn.verification.review.not_run": "Семантическое ревью не запускалось",
  "ui.sessionTurn.status.thinking": "Думаю",
  "ui.sessionTurn.status.thinkingWithTopic": "Думаю - {{topic}}",
  "ui.sessionTurn.status.thinkingPhrase.whirring": "Пу-пу-пу",
  "ui.sessionTurn.status.thinkingPhrase.boondoggling": "Вожусь",
  "ui.sessionTurn.status.thinkingPhrase.flummoxing": "Озадачиваюсь",
  "ui.sessionTurn.status.thinkingPhrase.cooking": "Готовлю ответ",
  "ui.sessionTurn.status.thinkingPhrase.crafting": "Формулирую",
  "ui.sessionTurn.status.thinkingPhrase.pondering": "Прикидываю",
  "ui.sessionTurn.status.thinkingPhrase.thinking": "Думаю",
  "ui.sessionTurn.status.thinkingPhrase.processing": "Обрабатываю",
  "ui.sessionTurn.status.gatheringThoughts": "Сбор мыслей",
  "ui.sessionTurn.status.consideringNextSteps": "Рассмотрение следующих шагов",

  "ui.messagePart.questions.dismissed": "Вопросы отклонены",
  "ui.messagePart.compaction": "Сессия сжата",
  "ui.messagePart.context.read.one": "{{count}} чтение",
  "ui.messagePart.context.read.other": "{{count}} чтений",
  "ui.messagePart.context.search.one": "{{count}} поиск",
  "ui.messagePart.context.search.other": "{{count}} поисков",
  "ui.messagePart.context.list.one": "{{count}} список",
  "ui.messagePart.context.list.other": "{{count}} списков",
  "ui.messagePart.diagnostic.error": "Ошибка",
  "ui.messagePart.title.edit": "Редактирую",
  "ui.messagePart.title.edit.completed": "Отредактировал",
  "ui.messagePart.title.write": "Записываю",
  "ui.messagePart.title.write.completed": "Записал",
  "ui.messagePart.option.typeOwnAnswer": "Введите свой ответ",
  "ui.messagePart.review.title": "Проверьте ваши ответы",

  "ui.list.loading": "Загрузка",
  "ui.list.empty": "Нет результатов",
  "ui.list.clearFilter": "Очистить фильтр",
  "ui.list.emptyWithFilter.prefix": "Нет результатов для",
  "ui.list.emptyWithFilter.suffix": "",

  "ui.messageNav.newMessage": "Новое сообщение",

  "ui.textField.copyToClipboard": "Копировать в буфер обмена",
  "ui.textField.copyLink": "Копировать ссылку",
  "ui.textField.copied": "Скопировано",

  "ui.imagePreview.alt": "Предпросмотр изображения",
  "ui.scrollView.ariaLabel": "прокручиваемый контент",

  "ui.tool.read": "Чтение",
  "ui.tool.loaded": "Прочитал",
  "ui.tool.list": "Список",
  "ui.tool.memory": "Память",
  "ui.tool.memory.remembered": "Запомнил",
  "ui.tool.memory.undo": "Отменить",
  "ui.tool.memory.undone": "Удалено из памяти",
  "ui.tool.glob": "Ищу файлы",
  "ui.tool.grep": "Ищу в файле",
  "ui.tool.search.completed": "Завершил поиск",
  "ui.tool.webfetch": "Webfetch",
  "ui.tool.webfetch.completed": "Завершил загрузку",
  "ui.tool.websearch": "Веб-поиск",
  "ui.tool.shell": "Терминал",
  "ui.tool.shell.completed": "Завершил команду",
  "ui.tool.patch": "Патч",
  "ui.tool.patch.completed": "Применил патч",
  "ui.tool.todos": "Задачи",
  "ui.tool.todos.read": "Читать задачи",
  "ui.tool.questions": "Вопросы",
  "ui.tool.questions.answered": "Ответил на вопросы",
  "ui.tool.agent": "Агент {{type}}",
  "ui.tool.agent.default": "Агент",
  "ui.tool.error.title": "Ошибка: {{tool}}",

  "ui.common.file.one": "файл",
  "ui.common.file.other": "файлов",
  "ui.common.question.one": "вопрос",
  "ui.common.question.other": "вопросов",

  "ui.common.add": "Добавить",
  "ui.common.back": "Назад",
  "ui.common.cancel": "Отмена",
  "ui.common.confirm": "Подтвердить",
  "ui.common.dismiss": "Закрыть",
  "ui.common.close": "Закрыть",
  "ui.common.download": "Скачать",
  "ui.common.next": "Далее",
  "ui.common.submit": "Отправить",

  "ui.permission.deny": "Запретить",
  "ui.permission.allowAlways": "Разрешить всегда",
  "ui.permission.allowOnce": "Разрешить один раз",

  "ui.message.expand": "Развернуть сообщение",
  "ui.message.collapse": "Свернуть сообщение",
  "ui.message.copy": "Копировать",
  "ui.message.copyMessage": "Копировать сообщение",
  "ui.message.forkMessage": "Ответвить в новую сессию",
  "ui.message.revertMessage": "Сбросить до этого момента",
  "ui.message.copyResponse": "Копировать ответ",
  "ui.message.copied": "Скопировано!",
  "ui.message.chatLink": "Чат",
  "ui.message.interrupted": "Прервано",
  "ui.message.queued": "В очереди",
  "ui.message.attachment.alt": "вложение",
  "ui.message.attachment.notPublished": "вложение не публикуется — файлы остаются на компьютере автора",

  "ui.patch.action.deleted": "Удалено",
  "ui.patch.action.created": "Создано",
  "ui.patch.action.moved": "Перемещено",
  "ui.patch.action.patched": "Изменено",

  "ui.question.subtitle.answered": "{{count}} отвечено",
  "ui.question.answer.none": "(нет ответа)",
  "ui.question.review.notAnswered": "(не отвечено)",
  "ui.question.multiHint": "Выберите все подходящие",
  "ui.question.singleHint": "Выберите один ответ",
  "ui.question.custom.placeholder": "Введите ваш ответ...",

  "ui.fileSearch.placeholder": "Найти",
  "ui.fileSearch.previousMatch": "Предыдущее",
  "ui.fileSearch.nextMatch": "Следующее",
  "ui.fileSearch.close": "Закрыть поиск",
  "ui.tool.task": "Задача",
  "ui.tool.task.completed": "Завершил задачу",
  "ui.tool.skill": "Навык",
  "ui.tool.skill.error": "Ошибка скилла",
  "ui.tool.skill.loading": "Загружаю скилл {{skill}}",
  "ui.tool.skill.preparing": "Готовлю скилл {{skill}}",
  "ui.tool.skill.using": "Применяю скилл {{skill}}",
  "ui.tool.skill.used": "Применил скилл {{skill}}",
  "ui.tool.details.path": "Путь",
  "ui.tool.details.pattern": "Шаблон",
  "ui.tool.details.include": "Фильтр",
  "ui.tool.details.query": "Запрос",
  "ui.tool.details.url": "URL",
  "ui.tool.details.agent": "Агент",
  "ui.tool.details.task": "Задача",
  "ui.tool.details.session": "Сессия",
  "ui.tool.details.description": "Описание",
  "ui.basicTool.called": "Вызван `{{tool}}`",
  "ui.toolErrorCard.failed": "Ошибка",
  "ui.toolErrorCard.copyError": "Скопировать ошибку",
  "ui.message.duration.seconds": "{{count}}с",
  "ui.message.duration.minutesSeconds": "{{minutes}}м {{seconds}}с",
}
